import React from "react";
import logger from "logger";

import AccountDetailsSection from "TaskHistory/Tasklet/SubTasklets/AccountDetailsSection.js";
import StatusSection from "TaskHistory/Tasklet/SubTasklets/StatusSection.js";
import ErrorLogsSection from "TaskHistory/Tasklet/SubTasklets/ErrorLogsSection.js";
import ActionsSection from "TaskHistory/Tasklet/SubTasklets/ActionsSection.js";
import TaskletCard from "./TaskletCard";
import CardContent from "@material-ui/core/CardContent";
import { getTroopNameFromId } from "Utils/Common";
import * as taskservice from "Utils/TaskService";
import { StringValue } from "./StringValue";
import { StringMap } from "./StringMap";
import { StringArray } from "./StringArray";

export default function(props) {
  const { task } = props;

  try {
    return (
      <TaskletCard title="Mine Booter/Shard Stealer">
        <CardContent>
          <AccountDetailsSection
            task={task}
            showOwner={props.showOwner}
            showUser={props.showUser}
          />
          <StatusSection task={task} />
          <StringValue
            label={"Atk Hero"}
            value={
              task.taskstatusdetail &&
              task.taskstatusdetail.selectedhero &&
              task.taskstatusdetail.selectedhero.heroname
            }
            valueParser={(v) => <>{v}</>}
          />
          <StringValue
            label={"Hits done"}
            value={
              <>
                {task.taskstatusdetail.bootcount}/
                {task.taskstatusdetail.noOfHits}
              </>
            }
          />
          <StringMap
            label={"Troops"}
            valueMap={task.taskstatusdetail.troops}
            valueParser={(k, v) => (
              <>
                {getTroopNameFromId(k)}: {v}
              </>
            )}
          />
          {task.taskstatusdetail.unboxtroops && (
            <StringValue
              label={"Auto Unbox Troops?"}
              value={task.taskstatusdetail.unboxtroops}
            />
          )}
          <StringValue
            label={"Steal only if shards more than"}
            value={task.taskstatusdetail.stealonlyshardsmorethan}
          />

          {task.taskstatusdetail.includeAllianceIds &&
            task.taskstatusdetail.includeAllianceIds.length > 0 && (
              <StringArray
                label={"Include Alliance Having Ids"}
                array={task.taskstatusdetail.includeAllianceIds}
                valueParser={(item) => `${item}`}
              />
            )}

          {task.taskstatusdetail.includeAllianceNames &&
            task.taskstatusdetail.includeAllianceNames.length > 0 && (
              <StringArray
                label={"Include Alliance Having Names"}
                array={task.taskstatusdetail.includeAllianceNames}
                valueParser={(item) => `${item}`}
              />
            )}

          {task.taskstatusdetail.includePlayerIds &&
            task.taskstatusdetail.includePlayerIds.length > 0 && (
              <StringArray
                label={"Include Players Having Ids"}
                array={task.taskstatusdetail.includePlayerIds}
                valueParser={(item) => `${item}`}
              />
            )}

          {task.taskstatusdetail.includePlayerNames &&
            task.taskstatusdetail.includePlayerNames.length > 0 && (
              <StringArray
                label={"Include Players Having Names"}
                array={task.taskstatusdetail.includePlayerNames}
                valueParser={(item) => `${item}`}
              />
            )}

          {task.taskstatusdetail.excludePlayerIds &&
            task.taskstatusdetail.excludePlayerIds.length > 0 && (
              <StringArray
                label={"Exclude Players Having Ids"}
                array={task.taskstatusdetail.excludePlayerIds}
                valueParser={(item) => `${item}`}
              />
            )}

          {task.taskstatusdetail.excludePlayerNames &&
            task.taskstatusdetail.excludePlayerNames.length > 0 && (
              <StringArray
                label={"Exclude Players Having Names"}
                array={task.taskstatusdetail.excludePlayerNames}
                valueParser={(item) => `${item}`}
              />
            )}

          {task.taskstatusdetail.bootlogs && (
            <>
              <div
                className="infokey enlargeonhover"
                onClick={(event) => {
                  taskservice.showAllNotifications(
                    task.taskstatusdetail.bootlogs
                  );
                }}
              >
                Boot Logs
                <span
                  style={{ float: "right", fontWeight: "bold", color: "red" }}
                >
                  [See All]
                </span>
              </div>
              {Object.keys(task.taskstatusdetail.bootlogs).map((key, index) => {
                if (index > 5) {
                  return null;
                }
                const value = task.taskstatusdetail.bootlogs[key];
                return (
                  <div
                    className="infovalue"
                    style={{ fontSize: "10px", maxWidth: "250px" }}
                  >
                    {value}
                  </div>
                );
              })}
            </>
          )}
          <ErrorLogsSection task={task} />
        </CardContent>
        <ActionsSection task={task} />
      </TaskletCard>
    );
  } catch (e) {
    console.error(e);
    return null;
  }
}
